import { Link } from 'react-router-dom'

export default function NotFoundPage() {
  return (
    <div className="min-h-[calc(100vh-64px)] flex items-center justify-center px-4">
      <div className="text-center">
        <p className="text-7xl mb-6">🐾</p>
        <h1 className="text-4xl font-bold text-gray-900 mb-3">Page not found</h1>
        <p className="text-gray-500 mb-8">Sorry, we couldn't find what you were looking for.</p>
        <Link to="/" className="btn-primary">Back to Home</Link>
      </div>
    </div>
  )
}
